export default defineNuxtRouteMiddleware(async (to, from) => {
    const authStore = useAuthStore();

    // Preserve person query parameter for impersonation across all navigation
    // Only preserve if navigating within the app (not to auth pages)
    const isAuthRoute = to.path.startsWith('/auth/');
    if (!isAuthRoute && from.query.person && !to.query.person) {
        // Redirect to same path but with person param preserved
        return navigateTo({
            path: to.path,
            query: { ...to.query, person: from.query.person }
        });
    }

    // Check if the route exists, otherwise redirect to not-found
    const router = useRouter();
    const resolved = router.resolve(to.fullPath);
    // If no matched route and not already on /not-found, redirect
    if (!resolved.matched.length && to.path !== '/not-found') {
        return navigateTo('/not-found');
    }

    // Check if page explicitly marks itself as public
    const isPagePublic = to.meta.public === true;

    // Initialize auth if not already done (but skip for public routes)
    if (!authStore.loggedIn && !isPagePublic) {
        await authStore.initializeAuth();
    }

    const isAuthenticated = authStore.loggedIn;

    // If not a public route and user is not authenticated, redirect to login
    if (!isPagePublic && !isAuthenticated) {
        // Set redirect cookie for where to go after login (path + query only)
        const redirectCookie = useCookie('pb-redirect');
        redirectCookie.value = to.fullPath;
        
        // Build login URL with email parameter if it exists
        let loginUrl = `/auth/login`;
        if (to.query.email) {
            loginUrl += `?email=${encodeURIComponent(to.query.email as string)}`;
        }
        
        return navigateTo(loginUrl);
    }

    // If user is authenticated but profile is not ready, redirect
    // to auth app for profile completion
    if (isAuthenticated && !isPagePublic && authStore.user && !authStore.user.identity.profile_ready) {
        const config = useRuntimeConfig();
        const redirectUrl = `${window.location.origin}${to.fullPath}`;
        await navigateTo(`${config.public.pb.authApp}?redirect_url=${encodeURIComponent(redirectUrl)}`, { external: true });
        return;
    }

    // Handle root path redirect
    if (to.path === '/') {
        if (isAuthenticated) {
            // Preserve query parameters when redirecting to dashboard
            return navigateTo({
                path: '/dashboard',
                query: to.query
            });
        } else {
            // Set redirect cookie for where to go after login (path + query only)
            const redirectCookie = useCookie('pb-redirect');
            redirectCookie.value = to.fullPath;
            
            // Build login URL with email parameter if it exists
            let loginUrl = `/auth/login`;
            if (to.query.email) {
                loginUrl += `?email=${encodeURIComponent(to.query.email as string)}`;
            }
            
            return navigateTo(loginUrl);
        }
    }
});
